import { render, staticRenderFns } from "./dashFaturamento.vue?vue&type=template&id=6039612c&scoped=true&"
import script from "./dashFaturamento.vue?vue&type=script&lang=js&"
export * from "./dashFaturamento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6039612c",
  null
  
)

export default component.exports